import { render, staticRenderFns } from "./OrganizationDialog.vue?vue&type=template&id=7954ed1f&scoped=true"
import script from "./OrganizationDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDialog.vue?vue&type=style&index=0&id=7954ed1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7954ed1f",
  null
  
)

export default component.exports